import { Injectable } from "@angular/core";
import {
  ExportContext,
  ExportFileFormat,
  ExportService,
  ExportTaskProcessor,
} from "app/layout/export-overlay";
import {
  VISIT_REPORT_DETAIL_EXPORT_ID,
  VISIT_REPORT_DETAIL_TITLE,
} from "./visit-report.constants";

@Injectable()
export class VisitDetailReportExport {
  constructor(private exportService: ExportService) {}

  export(format: ExportFileFormat, data) {
    this.exportService
      .task({
        id: VISIT_REPORT_DETAIL_EXPORT_ID,
        title: VISIT_REPORT_DETAIL_TITLE,
        format: format,
        iterations: 1,
        start: (ctx: ExportContext) => {
          ctx.processor.localizeItemProperties(VISIT_REPORT_DETAIL_TITLE, {
            shipToExternalKeyCode: "Código Socio",
            shipToName: "Socio de Negocio",
            reasonForVisitName: "Visita",
            serials: "Nro. Documento",
            dateTimeStart: "Fecha Hora Inicio",
            dateTimeEnd: "Fecha Hora Final",
            duration: "Duración Visita",
            geoPoint: "GPS APP",
            address: "GPS ERP",
            wasTheVisitOnSite: "Zona",
            validVisit: "Válida",
          });
        },
        next: (ctx: ExportContext) => {
          data.forEach((item) => {
            const formattedItem = {
              shipToExternalKeyCode: item.shipToExternalKeyCode,
              shipToName: item.shipToName,
              reasonForVisitName: item.reasonForVisitName,
              serials: item.serials,
              dateTimeStart: ExportTaskProcessor.types.excel.datetime(item.dateTimeStart),
              dateTimeEnd: ExportTaskProcessor.types.excel.datetime(item.dateTimeEnd),
              duration: this.formatDuration(item.duration),
              geoPoint: Array.isArray(item.geoPoint)
                ? item.geoPoint.join(", ")
                : "",
              address: Array.isArray(item.address?.[0]?.geolocationPoint)
                ? item.address[0].geolocationPoint.join(", ")
                : "",
              wasTheVisitOnSite: item.wasTheVisitOnSite ? "SI" : "NO",
              validVisit: item.validVisit ? "SI" : "NO",
            };
            ctx.processor.addToSection(
              VISIT_REPORT_DETAIL_TITLE,
              formattedItem
            );
          });
          ctx.next();
        },
      })
      .start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(VISIT_REPORT_DETAIL_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }

  private formatDuration(tiempoDecimal: number): string {
    if (tiempoDecimal == null || isNaN(tiempoDecimal)) {
      return "--:--:--";
    }
    // Calcular horas, minutos y segundos
    const horas = Math.floor(tiempoDecimal);
    const minutos = Math.floor((tiempoDecimal - horas) * 60);
    const segundos = Math.round(((tiempoDecimal - horas) * 60 - minutos) * 60);

    // Usar padStart para asegurar que siempre tenga 2 dígitos
    const horasFormateadas = String(horas).padStart(2, "0");
    const minutosFormateados = String(minutos).padStart(2, "0");
    const segundosFormateados = String(segundos).padStart(2, "0");

    // Devolver el tiempo en formato de "00:00:00"
    return `${horasFormateadas}:${minutosFormateados}:${segundosFormateados}`;
  }
}
